// extracted by mini-css-extract-plugin
export default {"ctn":"algorithm_ctn__xq-hz","textBox":"algorithm_textBox__sGIQj"};